import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import FooterNew from "../components/Footer-New.js";
import NavbarInner from "../components/Navbar-Inner.js";
import NavbarFixed from "../components/Navbar-Fixed.js";

// Images
import copy_icon from "../assets/images/copy_icon.svg";
import { Link } from "react-router-dom";

// import lib
import { dateTimeFormat } from "../lib/dateTimeHelper";

// import api
import { clearNotification } from "../api/users";
import NavbarInnerSide from "../components/NavbarInnerSide.js";
import Sidebar from "../components/Sidebar.js";


export default function Notification() {

  // hooks
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation()

  // redux-state
  const { unread } = useSelector((state) => state.notice)

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    return () => {
      clearNotification(dispatch)
    }
  }, [])

  return (
    <div>
    
      {/* <NavbarInner /> */}
      <NavbarInnerSide toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
      <div className="flex w-full relative">
        <Sidebar isOpen={isSidebarOpen} closeSidebar={() => setIsSidebarOpen(false)} />
        <div className="flex-1 w-full overflow-hidden p-4">
          <div className="">
            <div className="row">
              <div className="col-lg-12">
                <div class="text-[#395645] text-lg font-semibold mb-4"><h3>{t("NOTIFICATION")}</h3></div>
                <div className=" rounded-[4px] p-4 border border-[#6B7280]/25">
                  <div className="flex flex-col gap-4">
                    {
                      unread && unread.length > 0 && unread.map((item, key) => {
                        return (
                          <div className="notification_panel_row" key={key}>
                            <div>
                              <span className="unread_dot"></span>
                              <div className="notification_row_content">
                                <h2>{item.title}</h2>
                                <p>{item.description}</p>
                              </div>
                            </div>
                            <p className="notify_date">{dateTimeFormat(item.createdAt)}</p>
                          </div>
                        )
                      })
                    }
                    {unread && unread.length == 0 && <p>{t("NO_NOTIFICATION")}</p>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <FooterNew/> */}
      {/* <NavbarFixed /> */}
    </div>
  );
}
